module.exports = __webpack_public_path__ + "static/how-to-make-people-like-you-in-90-seconds-or-less-10e088640ab882cc14751dc19cfbd5f2.jpg";